import React, { createContext } from 'react';
import PropTypes from 'prop-types';

import { useSSRQuery } from '../../graphql';

import ALLEGIANT_STADIUM_BANNER_QUERY from './allegiantStadiumBannerProvider/allegiantStadiumBanner.query.graphql';
import IsStadium from '../../utils/isStadium';

export const AllegiantStadiumBannerContext = createContext(null);

const propTypes = {
  children: PropTypes.node,
};

const AllegiantStadiumBannerProvider = ({ children }) => {
  const {
    loading: loadingAllegiantStadiumBanner,
    error: allegiantStadiumBannerError,
    data: allegiantStadiumBannerData,
  } = useSSRQuery(ALLEGIANT_STADIUM_BANNER_QUERY, {
    skip: IsStadium(),
    cachePolicy: 'cache-and-network',
    ssr: false,
  });

  return (
    <AllegiantStadiumBannerContext.Provider
      value={{
        stadiumBannerData: {
          loadingAllegiantStadiumBanner,
          allegiantStadiumBannerError,
          allegiantStadiumBannerData,
        },
      }}
    >
      {children}
    </AllegiantStadiumBannerContext.Provider>
  );
};

AllegiantStadiumBannerProvider.propTypes = propTypes;

export default AllegiantStadiumBannerProvider;
